import { Notification } from '@dtpk-cc/components';

export const NoContractFoundError = () => (
    <Notification variant={Notification.Variant.alert} closable={false} noSideMargins noBottomMargin>
        <Notification.CopyText data-test-error="no_results">
            Leider konnte kein Vertrag gefunden werden. Bitte korrigieren Sie Ihre Angaben.
        </Notification.CopyText>
    </Notification>
);
